import React, { useEffect, useState, useContext } from "react";
import { Row, Col, Container } from "react-bootstrap";
import "../PrivacyPolicy/PrivacyPolicy.css";
import Privacypolicy from "../../../images/newIcon/Privacypolicy 1.svg";
import { trackEvent, trackPageView } from "../../utils/tracking";
import { Helmet } from "react-helmet";
import { HelmetProvider } from "react-helmet-async";
function PrivacyPolicy() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/Privacy-Policy",
      "jmf_policy-privacy",
    );
    // trackPageView(
    //   "http://localhost:710/Privacy-Policy",
    //   "jmf_policy-privacy"
    // );
    trackEvent({
      category: "Static Page",
      action: "PrivacyPolicy Page Loaded",
      label: "jmf_policy-privacy",
      value: 1,
    });
  }, []);

  const [path, setPathnameURL] = useState("");
  useEffect(() => {
    var pathnameurl = window.location.pathname;
    const regEx = new RegExp("-", "g");
    const resultName = pathnameurl.replace(regEx, " ");
    setPathnameURL(resultName);
  });
  return (
    <>
     <HelmetProvider>
                    <Helmet>
                    <meta charset="UTF-8" />
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1.0"
                    />
                    <meta
                        name="description"
                        content="Learn how JM Financial Mutual Fund collects, uses, safeguards, and manages your personal information through its Privacy Policy."
                    />
                    <meta
                        name="keywords"
                        content="jmf_privacy_policy, JM Financial Mutual Fund, privacy policy"
                    />
                    <title>
                        Privacy Policy | JM Financial Mutual Fund
                    </title>
                    </Helmet>
                </HelmetProvider>


      <section>
        <nav aria-label="main-navigation">
          <Container>
            <Row>
              <Col>
                <ul className="navigator-arrow">
                  <li>
                    <a href="/" aria-label="Home">
                      <i class="fa fa-home" aria-hidden="true"></i>
                    </a>{" "}
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </li>
                  {/* <li><a href="/NavsAndIDCW"><i>NavsAndIDCW</i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li> */}
                  {window.location.pathname != "" ? (
                    <li>{path.replace("/", "")}</li>
                  ) : (
                    ""
                  )}
                </ul>
              </Col>
            </Row>
          </Container>
        </nav>

        <main>
          <div className="privacy-link-data">
            <h1>
              <img
                src={Privacypolicy}
                className="img-dis"
                alt="Privacypolicy"
                height={60}
                width={60}
              ></img>
              <span className="disclaimer-text">Privacy Policy</span>
              {/* Privacy Policy */}
            </h1>
          </div>
          <Container>
            <Row>
              <Col sm={12}>
                <div className="privacy-policy">
                  <p>
                    We, at JM Financial Asset Management Ltd, respect
                    investors/customers/clients right to privacy. We recognise
                    that the lawful and correct treatment of personal data is
                    very important to maintain investor's confidence in
                    ourselves. It is our endeavor to ensure that any personal
                    data that we collect, process, record or use in any way
                    whether it is held on paper, on computer or other electronic
                    media will have appropriate safeguards in place to comply
                    with our obligations of confidentiality and privacy. In this
                    regard, we request investors/clients/customers to kindly
                    read this “Policy on Privacy and Security of Information”
                    carefully. The terms as may be used in this document would
                    be in accordance with “The Information Technology Act 2000
                    as amended till date, Information Technology (Reasonable
                    security practices and procedures and sensitive personal
                    data or information) Rules, 2011” and such other
                    rules/regulations and Circulars as may be applicable.
                  </p>
                  <h2>Interpretation</h2>
                  <ul>
                    <li>
                      All references to the masculine shall include the feminine
                      and all references, to the singular shall include the
                      plural and vice-versa. All references to
                      client/customer/investor whether masculine or feminine
                      include references to non-individuals also unless
                      repugnant to the context thereof;
                    </li>
                    <li>
                      Any reference to any statute or statutory provision shall
                      be construed as including a reference to any statutory
                      modifications or re-enactment therein from time to time;
                    </li>
                    <li>Headings are for ease of reference only.</li>
                  </ul>
                  {/* </div>
                            <div> */}
                  <h2>The Policy</h2>
                  <p>
                    JM Financial Asset Management Ltd (‘AMC’), a Company
                    incorporated under the Companies Act, 1956, has been
                    appointed as the Investment Manager to the Schemes of JM
                    Financial Mutual Fund (‘JMF MF’), a mutual fund registered
                    with Securities and Exchange Board of India (‘SEBI’). JM
                    Financial Trustee Company Private Limited. (Trustee Company)
                    is the Trustee to the Mutual Fund. JM Financial Limited is
                    the Sponsor(s) of the Mutual Fund.
                  </p>
                  <p>
                    The AMC Board either directly or through third party service
                    providers engaged by the AMC Board(Service Providers) such
                    as the Registrar and Transfer agents collects, receives,
                    possesses, stores, deals or handles information received
                    from investors/client/customers whether existing or
                    prospective. Such information can be personal and sensitive
                    in nature as per the indicative list given below:
                  </p>
                  <ul>
                    <li>
                      Bank Account details change of bank account details or
                      registration of multiple bank accounts etc. through
                      application forms;
                    </li>
                    <li>
                      Payment instrument details at the time of submitting
                      application at the time of investment or as proof for
                      carrying out change of bank account or any other details
                      of debit card obtained (if any);
                    </li>
                    <li>
                      Generation and storing password (PIN) in encrypted form
                      based on the request from the investor under the online
                      mode of investments;
                    </li>
                    <li>Biometric information obtained, if any;</li>
                    <li>
                      Demat Account details like beneficiary account no. etc.;
                    </li>
                    <li>Annual Income and savings profile; and</li>
                    <li>
                      Other information as may be considered as sensitive and
                      personal.
                    </li>
                  </ul>
                  <p>
                    The aforesaid information is being collected by the AMC
                    Board/Service Providers to respond to your requests, to
                    process the investment applications and to also ensure safe
                    subscriptions/redemptions through points of acceptance in
                    physical form, website, online portals, Automated Teller
                    Machines and such other mode. The AMC Board may also call
                    the investors to inform them with respect to the other
                    products or services offered by the AMC Board. The said
                    information is also being collected to be compliant with the
                    Know Your Client (KYC) norms under the Prevention of Money
                    Laundering Act, 2002, (PMLA), the rules issued thereunder,
                    and guidelines and circular on Anti- Money Laundering issued
                    by SEBI and SEBI (Mutual Funds) Regulations, 1996 as amended
                    till date.
                  </p>
                  <p>
                    The aforesaid information is the basis of our ability to
                    provide investors/clients/customers with good, qualitative,
                    timely and efficient service, while also keeping the
                    information and data provided totally secure and
                    confidential.
                  </p>
                  <p>
                    We endeavor to have suitable technical, operational and
                    physical security controls and measures to protect
                    investors/customers/clients personal/sensitive data or
                    information that are commensurate with the nature of our
                    business at all times.
                  </p>
                  <p>
                    We permit only authorized employees who are trained in the
                    proper handling of customer information, to have access to
                    aforesaid information. We would ensure to enter into
                    suitable terms with third party service providers in order
                    to protect client confidentiality and follow a
                    non-disclosure or restricted disclosure policy. Further, the
                    employees who violate the privacy and confidentiality
                    promise shall be subjected to disciplinary action.
                  </p>
                  <p>
                    We shall reveal only such information to external
                    authorities as may be found relevant and necessary in order
                    to comply with the applicable laws of the land and to third
                    party service providers to ensure smooth functioning of the
                    activities as may be prescribed under applicable laws like
                    Registrar and Transfer
                    Agents/distributors/banks/sub-brokers/call-centers/custodians/depositories
                    and such other entities/persons. By using our website or by
                    agreeing to transact with us, you agree to the above sharing
                    of information during your relationship with us. We may also
                    be required from time to time to disclose
                    investors/customers/clients personal information to
                    governmental or judicial bodies or agencies or our
                    regulators based on their requirement to comply with the
                    applicable laws including cyber laws. In addition to the
                    above we may also use the information shared by
                    investors/clients/customers to contact
                    investors/clients/customers regarding the products and
                    services offered by us and seek feedback on the services
                    provided. Further, such information may also be used by us
                    to generate statistics and reports and/or to protect and
                    defend the rights, interest and property of the Mutual Fund,
                    AMC, Trustee Company, Sponsors & its affiliates and
                    directors and/or to enforce legal rights or provisions of
                    the Scheme related Documents of the Mutual Fund viz. Scheme
                    Information Document (SID), Statement of Additional
                    Information (SAI) and Key Information Memorandum (KIM).
                    Further, it may be noted that Internet Protocol (IP)
                    addresses, browser supplied information and site session
                    information may be recorded as part of the normal operations
                    and for security monitoring purposes.
                  </p>
                  <p>
                    Nevertheless, it is our foremost endeavor to ensure that the
                    Customer’s Privacy is protected at all points in time. The
                    customers/clients (whether existing/prospective) must ensure
                    to recheck the information or data being provided to the AMC
                    Board or any person acting on its behalf. Incase if any of
                    the data/information is found to be inaccurate or incorrect,
                    the same shall be informed to the AMC Board for immediate
                    amendment. The AMC Board and any person acting on its behalf
                    shall not be responsible for the authenticity of the
                    personal information or sensitive personal data or
                    information supplied by the customers/clients (whether
                    existing/prospective).
                  </p>
                  <p>
                    Our website may use cookies. By using our website and
                    agreeing to these terms of use, you consent to our use of
                    cookies in accordance with the terms of our privacy policy.
                  </p>
                  <p>
                    Investors/ Customers/ Clients shall not be covered by the
                    terms of this Policy if they access other websites using
                    links from this website.
                  </p>
                  <p>
                    Further, despite our efforts to protect
                    investors/customers/clients privacy, if unauthorized persons
                    breach security control measures and illegally use such
                    sensitive/personal data or information, the Mutual Fund,
                    AMC, Trustee Company, Sponsors and its affiliates and
                    directors shall not be held responsible/liable.
                  </p>
                  <h2>Amendments/Modifications</h2>
                  <p>
                    This Privacy Policy available on our website is current and
                    valid. However, the AMC Board reserves the right to
                    amend/modify any of the sections of this policy at any time
                    and the clients/customers/investors are requested to keep
                    themselves updated for changes by reading the same from time
                    to time.
                  </p>
                  <h2>Retention of information/data</h2>
                  <p>
                    It may be noted that we may retain the data as may be
                    provided by the client/investors/customers till such time as
                    may be provided under the law and as required to efficiently
                    provide service to the clients/investors/ customers.
                  </p>
                  <h2>Grievance redressal</h2>
                  <p>
                    If investors/customers/clients have any concerns relating to
                    their personal and sensitive information they may be
                    addressed to investor@jmfl.com. For more details please
                    refer to the Scheme related documents available on our
                    website viz. www.jmfinancialmf.com.
                  </p>

                  <p className="privacy-consent">
                    Investors/clients/customers shall have expressly consented
                    to the terms of this Policy if they enter and use this
                    website or provide any information while transacting with
                    us.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </main>
      </section>
    </>
  );
}

export default PrivacyPolicy;
